import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IStoreSettings } from '../../../../../../../common/common-interfaces/store-settings';
import { IStoreSummaryData, IVendorCostSummary } from '../../../../../../../common/common-interfaces/store-statistics';
import { Api } from '../../../services/api';
import { Globals } from '../../../services/globals';
import moment from 'moment';
import { Utility } from 'src/app/services/utility';

@Component({
    selector: 'stores',
    templateUrl: './stores.component.html',
    styleUrls: ['./stores.component.scss'],
    standalone: false
})
export class StoresComponent {
  stores: IStoreSettings[];
  storeSummaries: { [id: string]: IStoreSummaryData } = {};

  aceStores: IStoreSettings[];
  partnerStores: IStoreSettings[];
  showDisabledStores: boolean = false;
  showSandboxStores: boolean = true;

  periodStart: Date;
  periodEnd: Date;
  vendorCommissions: { [name: string]: IVendorCostSummary & { sortedSkus?: any[] } } = {};
  expandedVendor: string;
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals, public utility: Utility) {

  }

  async ngOnInit() {
    this.periodStart = moment().subtract(1, 'month').toDate();
    this.periodEnd = moment().toDate();
    this.loadStoreVisibilityPreferences();
    await this.fetchStores();
  }

  loadStoreVisibilityPreferences() {
    let preferences = this.globals.currentUser && this.globals.currentUser.preferences && this.globals.currentUser.preferences.stores;

    this.showDisabledStores = !!(preferences && preferences.showDisabledStores);
    this.showSandboxStores = preferences && preferences.showSandboxStores !== undefined ? preferences.showSandboxStores : true;
  }

  async storeVisibilityPreferencesChanged() {
    if (!this.globals.currentUser)
      return;

    this.globals.currentUser.preferences = {
      ...(this.globals.currentUser.preferences || {}),
      stores: {
        ...((this.globals.currentUser.preferences && this.globals.currentUser.preferences.stores) || {}),
        showDisabledStores: this.showDisabledStores,
        showSandboxStores: this.showSandboxStores
      }
    };

    this.globals.currentUser = await this.api.user().patch<any>(`/current/preferences`, {
      preferences: this.globals.currentUser.preferences
    });
    this.loadStoreVisibilityPreferences();
  }

  shouldDisplayStore(store: IStoreSettings) {
    return (this.showDisabledStores || !store.disabled)
      && (this.showSandboxStores || !store.sandbox);
  }

  abs(val) {
    return Math.abs(val);
  }

  expandVendor(vendor) {
    if (vendor == this.expandedVendor)
      this.expandedVendor = null;
    else
      this.expandedVendor = vendor;
  }

  getMargin(store) {
    if (this.storeSummaries[store._id].costs.total && this.storeSummaries[store._id].sales.total) {
      return `${this.utility.numberFormat(((this.storeSummaries[store._id].sales.total - this.storeSummaries[store._id].costs.total) / this.storeSummaries[store._id].sales.total) * 100)}%`;
    }
    else {
      return '-';
    }
  }

  getPartnerMargin(store) {
    if (this.storeSummaries[store._id].costs.total && this.storeSummaries[store._id].usedCredits.total) {
      return `${this.utility.numberFormat(((this.storeSummaries[store._id].usedCredits.total - this.storeSummaries[store._id].costs.total) / this.storeSummaries[store._id].usedCredits.total) * 100)}%`;
    }
    else {
      return '-';
    }
  }

  async fetchStores() {
    this.stores = await this.api.admin().get<any>(`/stores`);
    this.aceStores = [];
    this.partnerStores = [];
    this.storeSummaries = {};
    this.vendorCommissions = {};
    this.expandedVendor = null;

    if (this.globals.currentUser) {
      for (let store of this.stores) {
        if (store.type == 'partner')
          this.partnerStores.push(store);
        else
          this.aceStores.push(store);
      }
    }

    if (this.stores && this.stores.length) {
      for (let store of this.stores) {
        if (!store.credits)
          store.credits = 0;
        this.storeSummaries[store._id] = await this.api.store(store).get<any>(`/summary?startDate=${moment(this.periodStart).toISOString()}&endDate=${moment(this.periodEnd).endOf('day').toISOString()}`);

        if (!this.storeSummaries[store._id].costs.total
          && !this.storeSummaries[store._id].sales.total) {
          //  delete this.storeSummaries[store._id];
          //  continue;
        }

        if (!this.globals.currentUser) {
          if (store.type == 'partner')
            this.partnerStores.push(store);
          else
            this.aceStores.push(store);
        }

        for (let vendor in this.storeSummaries[store._id].costs.vendors) {
          if (!this.vendorCommissions[vendor])
            this.vendorCommissions[vendor] = { skus: {}, total: 0 };
          this.vendorCommissions[vendor].total += this.storeSummaries[store._id].costs.vendors[vendor].total;
          for (let sku in this.storeSummaries[store._id].costs.vendors[vendor].skus) {
            if (!this.vendorCommissions[vendor].skus[sku])
              this.vendorCommissions[vendor].skus[sku] = 0;
            this.vendorCommissions[vendor].skus[sku] += this.storeSummaries[store._id].costs.vendors[vendor].skus[sku];
          }
        }
      }

      for (let vendor in this.vendorCommissions) {
        let array = Object.entries(this.vendorCommissions[vendor].skus);
        array.sort(([skuA, a], [skuB, b]) => b - a);
        this.vendorCommissions[vendor].sortedSkus = array;

      }
    }
  }

}
